// src/TaskNotifier.js
import { useEffect } from "react";
import { fetchTasks } from "./api";
import { useAuth } from "./AuthContext";

const TaskNotifier = () => {
  const { token } = useAuth();
  const userEmail = localStorage.getItem("userEmail");

  useEffect(() => {
    if (!token) return;

    const interval = setInterval(async () => {
      try {
        const tasks = await fetchTasks(token);
        const now = new Date();
        const soon = new Date(now.getTime() + 15 * 60 * 1000);

        const tasksToNotify = tasks.filter(
          (t) =>
            t.due_datetime &&
            !t.completed &&
            new Date(t.due_datetime) > now &&
            new Date(t.due_datetime) <= soon
        );

        if (tasksToNotify.length > 0) {
          const payload = {
            app_id: "20b29d87-7fe4-4ca8-9b2b-17e48be459f0",
            filters: [{ field: "tag", key: "email", relation: "=", value: userEmail }],
            headings: { en: "🕒 Promemoria Task" },
            contents: {
              en: `Hai ${tasksToNotify.length} attività da completare entro 15 minuti!`,
            },
          };

          await fetch("https://onesignal.com/api/v1/notifications", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "os_v2_app_eczj3b374rgkrgzlc7sixzcz6bds3lefecgej2n2bebbenz7hed6jzoacqifpfxtwwxkdpqu3xtrdtr7bzia55luyygpe4ek3do64ry", // sostituisci con la tua chiave OneSignal
            },
            body: JSON.stringify(payload),
          });

          console.log("🔔 Notifica inviata:", tasksToNotify.length);
        }
      } catch (err) {
        console.error("Errore invio notifica:", err);
      }
    }, 60000); // ogni minuto

    return () => clearInterval(interval);
  }, [token]);

  return null;
};

export default TaskNotifier;
